import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { JWT, launchConfigs, ltiParams } from '../interfaces/config.interface';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private http: HttpClient) {}

  processRequest(configs: launchConfigs) {
    return new Promise<ltiParams>((resolve, reject) => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const launchId = urlParams.get('launchId');

      if (launchId) {
        this.generateToken(configs.createTokenApiUrl, launchId).then(
          (responses) => {
            if (responses?.JWT) {
              sessionStorage.setItem('JWT', responses?.JWT.toString());
              this.getLtiParams(configs.paramsApiUrl).then(
                (responses) => {
                  resolve(responses!);
                },
                (error) => {
                  reject(error);
                },
              );
            }
          },
          (error) => {
            reject(error);
          },
        );
      } else if (sessionStorage.getItem('JWT')) {
        this.getLtiParams(configs.paramsApiUrl).then(
          (responses) => {
            resolve(responses!);
          },
          (error) => {
            reject(error);
          },
        );
      } else {
        reject();
        if (configs.environmentName !== 'local' && configs.redirectUrl) {
          console.log('Invalid session');
          location.href = configs.redirectUrl;
        }
      }
    });
  }

  generateToken(tokenUrl: string, uniqueKey: string) {
    const reqObject = {
      uniqueKey: uniqueKey,
    };
    return this.http
      .post<JWT>(tokenUrl, reqObject)
      .pipe(
        tap((res: JWT) => {
          return res;
        }),
        catchError(this.handleError),
      )
      .toPromise();
  }

  getLtiParams(paramsApiUrl: string) {
    return this.http
      .post<ltiParams>(`${paramsApiUrl}`, {})
      .pipe(
        tap((data: ltiParams) => {
          return data;
        }),
        catchError(this.handleError),
      )
      .toPromise();
  }

  handleError(error: HttpErrorResponse) {
    return throwError(() => {
      return error;
    });
  }
}
